/** Saves that "Undo last save" can reverse (docs/features/operator-ux.md). */
export const UNDOABLE = /^\/(counts\/[^/]+\/observations|movements|orders\/[^/]+\/receive|batches)$/;
/** App.tsx announces each successful change with this event. */
export const SAVED_EVENT = "parlyst:saved";
